// Flag used to disable GraphQL queries that are no longer backed by a
// database collection (e.g. GetGdprRule, QuestionCountsByEntityType).
// Toggle to `false` to re-enable the affected queries.
export const SKIP_DISABLED_QUERY = true;
